import SubHeaders from '@/components/Headers/SubHeaders'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { getLocation } from '../../services'
import { paths } from '@/utils/path'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { GridInformation, Tabs } from 'vnetwork-ui'
import { Badge } from '@/components/ui/badge'
import useTabs from '@/hooks/useTabs'
import { formatDateTime } from '../../utils'
import { tabs } from './tabs'

const LocationDetail = () => {
    const { id } = useParams<{ id: string }>()

    const { data: location, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.WAREHOUSE_LOCATIONS, id],
        queryFn: () => getLocation(id!),
    })

    const { TabComponent, TabProps } = useTabs({ tabs: tabs(location) })

    // Render loading/error state at the end (after all hooks)
    if (renderState()) return renderState()

    // Helper to get location type badge variant
    const getLocationTypeBadgeVariant = (type: string) => {
        switch (type?.toLowerCase()) {
            case 'warehouse':
                return 'default'
            case 'datacenter':
                return 'secondary'
            default:
                return 'outline'
        }
    }

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                    {
                        path: paths.warehouseLocations,
                        title: 'Locations',
                    },
                    {
                        path: '',
                        title: location?.name || '',
                    },
                ]}
            />
            <GridInformation
                data={[
                    {
                        label: 'Location Code',
                        value: location?.code || '-',
                    },
                    {
                        label: 'Location Name',
                        value: location?.name || '-',
                    },
                    {
                        label: 'Type',
                        value: (
                            <Badge
                                variant={getLocationTypeBadgeVariant(
                                    location?.type || ''
                                )}
                            >
                                {location?.type?.toUpperCase() || ''}
                            </Badge>
                        ),
                    },
                    {
                        label: 'Status',
                        value: (
                            <Badge
                                variant={
                                    location?.is_active
                                        ? 'default'
                                        : 'destructive'
                                }
                            >
                                {location?.is_active ? 'ACTIVE' : 'INACTIVE'}
                            </Badge>
                        ),
                    },
                    {
                        label: 'Address',
                        value: location?.address || '-',
                        className: 'lg:col-span-2',
                        hidden: !location?.address,
                    },
                    {
                        label: 'Notes',
                        value: location?.notes || '-',
                        className: 'lg:col-span-2',
                        hidden: !location?.notes,
                    },
                    {
                        label: 'Created At',
                        value: formatDateTime(location?.created_at),
                    },
                    {
                        label: 'Updated At',
                        value: formatDateTime(location?.updated_at),
                    },
                ]}
                head={{
                    title: 'Location Information',
                }}
            />

            <Tabs {...TabProps} />

            {TabComponent}
        </div>
    )
}

export default LocationDetail
